import { createSlice } from "@reduxjs/toolkit";
import { Status } from "lib/enums";
import { getCalculateBitrateThunk, getQuickStartThunk, postQuickStartThunk} from "./toolsActions";
import type { QuickStartResponse } from "lib/types";
//import { RootState } from "../../store";

type ToolsActionDataState = {
    data: number,
    calculateBitrateStatus: Status,
    quickStartData: QuickStartResponse | null,
    quickStartStatus: Status,
    backendErrors: {
        getProjectError: string,
        postSiteDesignError: string
    }
};

const initialState: ToolsActionDataState = {
    data: 2702,
    calculateBitrateStatus: Status.Idle,
    quickStartData: null,
    quickStartStatus: Status.Idle,
    backendErrors: {
        getProjectError: '',
        postSiteDesignError: ''
    }
};

const calculateBitrateSlice = createSlice({
    name: 'calculateBritrate',
    initialState: initialState,
    reducers: {},
    extraReducers: builder => builder
        .addCase(getCalculateBitrateThunk.pending, state => {
            state.calculateBitrateStatus = Status.Pending;
        })        
        .addCase(getCalculateBitrateThunk.fulfilled, (state, action) => {          
            state.calculateBitrateStatus = Status.Success;          
        })
        .addCase(getCalculateBitrateThunk.rejected, (state, action) => {
            state.calculateBitrateStatus = Status.Rejected;
        })
        .addCase(getQuickStartThunk.pending, state => {
            state.quickStartStatus = Status.Pending;
        })
        .addCase(getQuickStartThunk.fulfilled, (state, action) => {
            state.quickStartStatus = Status.Success;
            state.quickStartData = action.payload ?? null;
            state.backendErrors.getProjectError = ''    
        })
        .addCase(getQuickStartThunk.rejected, (state, action) => {
            state.quickStartStatus = Status.Rejected;
            state.quickStartData = null;
            state.backendErrors.getProjectError = action?.payload || 'Failed to fetch quick start data'
        })
        .addCase(postQuickStartThunk.pending, state => {
            state.quickStartStatus = Status.Pending;
        })
        .addCase(postQuickStartThunk.fulfilled, (state, action) => {
            state.quickStartStatus = Status.Success;
            state.quickStartData = action.payload ?? null;
            state.backendErrors.getProjectError = ''    
        })
        .addCase(postQuickStartThunk.rejected, (state, action) => {
            state.quickStartStatus = Status.Rejected;
            state.quickStartData = null;
            state.backendErrors.getProjectError = action?.payload ||'Failed to send quick start data'
        })
});

//if you need the spinner
//export const calculateBitrateStatusLoading = (state: RootState): boolean => Object.values(state.toolsAction.calculateBitrateStatus).some(status => status === Status.Pending)

export default calculateBitrateSlice.reducer;
